import { useContext, useEffect } from 'react';

import { HeaderContext } from '@app/providers/HeaderProvider';
import { useRecordModalContext } from '@app/providers/RecordModalProvider';
import { addEnterKeyListener } from '@app/utils/addEnterKeyListener';

import type { NRecordsList } from '@pages/Clients/Records/RecordsList.types';

export const useRecordsEffects = ({
  isLoading,
  submitForm,
  getInitialTableData,
}: NRecordsList.UseRecordsEffectsProps) => {
  const { setHeader: setRecordsProviderData } = useContext(HeaderContext);
  const { isNeedToUpdateRecordsRegistry, setIsNeedToUpdateRecordsRegistry } =
    useRecordModalContext();

  useEffect(() => {
    getInitialTableData();
  }, [getInitialTableData]);

  useEffect(() => {
    isLoading && getInitialTableData();
  }, [isLoading, getInitialTableData]);

  useEffect(() => {
    return addEnterKeyListener({ callback: submitForm });
  }, [submitForm]);

  useEffect(() => {
    if (isNeedToUpdateRecordsRegistry) {
      setIsNeedToUpdateRecordsRegistry(false);
      setRecordsProviderData((prev) => ({
        ...prev,
        pageNumber: 1,
      }));
      submitForm();
    }
  }, [
    setRecordsProviderData,
    isNeedToUpdateRecordsRegistry,
    setIsNeedToUpdateRecordsRegistry,
    submitForm,
  ]);
};
